import {
  Button,
  Col,
  Divider,
  Modal,
  Pagination,
  Popover,
  Row,
  Select,
  Tag,
} from "antd";
import { COLORS } from "../../constants/Colors";
import Typography from "../Typography";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import React, { useState } from "react";
import ShipmentDetailModal from "../ShipmentDetailModal";
import _, { size } from "lodash";
import moment from "moment/moment";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import exportimg from "../../assets/export.svg";
import ConfirmChagneQueue from "./modal/confirm";
import MyButton from "../Button";
import { UpdateStatusQueue } from "../../controllers/home/CardHomeAPI";
import { errorNotification, successNotification } from "../Notification";

const { confirm } = Modal;

export const QueueListItem = (props) => {
  const isDesktop = useIsDesktop();
  const { queueInfo, handleClickOpenModal } = props;
  const Lang = localStorage.getItem("lang");
  const {
    statusText,
    statusColor,
    orderNo,
    deliveryDateTimeTxt,
    deliveryTimeTxt,
    deliveryDateNewTxt,
  } = queueInfo;
  const name = _.get(queueInfo, "customer.comtomerName");
  const address = _.get(queueInfo, "destination.address");
  const colQueue = 12;
  const colQueueInsideRight = 8;
  const colQueueInside = isDesktop ? 4 : 12;
  const colQueueInsideMiddle = isDesktop ? 4 : 12;
  const colQueueInsideEnd = isDesktop ? 4 : 12;
  const paddingCol = isDesktop ? "p-2" : "p-2";
  const classNameCol = isDesktop
    ? "column-queue p-2 "
    : "column-queue p-2 mt-2";
  const classNameColEnd = isDesktop
    ? "column-queue-white p-2 "
    : "column-queue-white-mobile p-2 mt-2";
  return (
    <div className="w-100" style={{ padding: "8px 16px" }}>
      {isDesktop ? (
        <Row
          gutter={8}
          style={{
            paddingTop: "4px",
            paddingBottom: "0px",
            height: "89px",
          }}
        >
          <Col className="gutter-row" span={colQueueInside}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                <FormattedMessage id="QueueTag" defaultMessage="Queue" />
              </Typography>
              <Typography
                className="p-2"
                isBold
                color={COLORS.Dark}
                size={"24px"}
              >
                {_.get(queueInfo, "queueNo") || "-"}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInside}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                <FormattedMessage
                  id="HomeParkingNo"
                  defaultMessage="ช่องจอด เลขตู้"
                />
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(queueInfo, "source")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideMiddle}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(queueInfo, "serialNoMarket")}
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(queueInfo, "assetNameMarket")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideEnd}>
            <div className={classNameColEnd}>
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(queueInfo, "parcel")}{" "}
                <FormattedMessage
                  id="HomeParkingList"
                  defaultMessage="รายการ"
                />
              </Typography>

              <Typography className="p-2" color={COLORS.Dark} size={"13px"}>
                <FormattedMessage id="queueWaiting" defaultMessage="รอแล้ว" />
                {" " + _.get(queueInfo, "waitingTime") + " "}
                {/* <FormattedMessage id="queueMinute" defaultMessage="นาที" /> */}
              </Typography>
            </div>
          </Col>

          <Col className="right-tag-column" span={colQueueInsideRight}>
            <Row>
              <Col className="right-tag-column" span={24}>
                <Tag
                  className="tag-queue-right"
                  style={{ height: "24px" }}
                  color={_.get(queueInfo, "statusMapView.color")}
                >
                  <Typography
                    className="p-1"
                    isBold
                    color={COLORS.White}
                    size={"14px"}
                    textAlign={"center"}
                  >
                    {Lang === "TH"
                      ? _.get(queueInfo, "statusMapView.txt.TH")
                      : _.get(queueInfo, "statusMapView.txt.EN")}
                  </Typography>
                </Tag>
              </Col>
              <Col className="right-tag-column" span={24}>
                <Typography className="p-2" color={COLORS.Dark} size={"15px"}>
                  {_.get(queueInfo, "completedAtDate") &&
                  _.get(queueInfo, "isShowCompletedAt") ? (
                    <>
                      <FormattedMessage
                        id="shipWhen"
                        defaultMessage="จัดส่งเมื่อ"
                      />
                      {" " +
                        _.get(queueInfo, "completedAtDate") +
                        " " +
                        _.get(queueInfo, "completedAtTime")}
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </Col>
              <Col className="right-tag-column" span={24}>
                <Typography className="p-2" color={COLORS.Dark} size={"15px"}>
                  {_.get(queueInfo, "confirmedAtDate") ? (
                    <>
                      <FormattedMessage
                        id="createdWhen"
                        defaultMessage="สร้างเมื่อ"
                      />
                      {" " +
                        _.get(queueInfo, "confirmedAtDate") +
                        " " +
                        _.get(queueInfo, "confirmedAtTime")}
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row
          gutter={8}
          style={{
            paddingTop: "8px",
            paddingBottom: "8px",
            // height: '89px'
          }}
        >
          <Col className="gutter-row" span={colQueueInside}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                <FormattedMessage id="QueueTag" defaultMessage="Queue" />
              </Typography>
              <Typography
                className="p-2"
                isBold
                color={COLORS.Dark}
                size={"24px"}
              >
                {_.get(queueInfo, "queueNo") || "-"}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInside}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                <FormattedMessage
                  id="HomeParkingNo"
                  defaultMessage="ช่องจอด เลขตู้"
                />
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(queueInfo, "source")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideMiddle}>
            <div className={classNameCol}>
              {" "}
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(queueInfo, "serialNoMarket")}
              </Typography>
              <Typography
                className="p-2"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  lineHeight: "1.0em",
                  maxHeight: "2.56em",
                }}
                color={COLORS.Dark}
                size={"15px"}
              >
                {_.get(queueInfo, "assetNameMarket")}
              </Typography>
            </div>
          </Col>
          <Col className="gutter-row" span={colQueueInsideEnd}>
            <div className={classNameColEnd}>
              <Typography
                className={paddingCol}
                isBold
                color={COLORS.GreenBrown}
                size={"14px"}
              >
                {_.get(queueInfo, "parcel")}{" "}
                <FormattedMessage
                  id="HomeParkingList"
                  defaultMessage="รายการ"
                />
              </Typography>

              <Typography className="p-2" color={COLORS.Dark} size={"12px"}>
                <FormattedMessage id="queueWaiting" defaultMessage="รอแล้ว" />
                {" " + _.get(queueInfo, "waitingTime") + " "}
              </Typography>
            </div>
          </Col>

          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "16px",
            }}
          >
            <Tag
              className="tag-queue-right"
              style={{ height: "24px" }}
              color={_.get(queueInfo, "statusMapView.color")}
            >
              <Typography
                className="p-1"
                isBold
                color={COLORS.White}
                size={"14px"}
                textAlign={"center"}
              >
                {Lang === "TH"
                  ? _.get(queueInfo, "statusMapView.txt.TH")
                  : _.get(queueInfo, "statusMapView.txt.EN")}
              </Typography>
            </Tag>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <Typography
                  className="px-2 pt-3"
                  color={COLORS.Dark}
                  size={"14px"}
                >
                  {_.get(queueInfo, "completedAtDate") &&
                  _.get(queueInfo, "isShowCompletedAt") ? (
                    <>
                      <div>
                        <FormattedMessage
                          id="shipWhen"
                          defaultMessage="จัดส่งเมื่อ"
                        />
                      </div>
                      <div>
                        {_.get(queueInfo, "completedAtDate") +
                          " " +
                          _.get(queueInfo, "completedAtTime")}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Typography className="p-2" color={COLORS.Dark} size={"14px"}>
                  {_.get(queueInfo, "confirmedAtDate") ? (
                    <>
                      <div>
                        <FormattedMessage
                          id="createdWhen"
                          defaultMessage="สร้างเมื่อ"
                        />
                      </div>
                      <div>
                        {_.get(queueInfo, "confirmedAtDate") +
                          " " +
                          _.get(queueInfo, "confirmedAtTime")}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
};

const QueueList = (props) => {
  const {
    trackingDetail,
    queueData,
    total,
    handleChangePage,
    setEvent,
    exportOrdersList,
    isDesktop,
    openViewQueue,
    onClickView,
    pagination,
    handleChangeSize,
    size,
    recordQueue,
    openChangeQueue,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [detailModal, setDetailModal] = useState([]);
  const [fromTracking, setFromTacking] = useState(true);
  const [offsetPopover, setOffsetPopover] = useState({ left: 0, top: 0 });
  const intl = useIntl();
  const [visiblePop, setVisiblePop] = useState(false);

  const handleDivClick = (event) => {
    const { clientX, clientY } = event;
    const xOffset = -25;
    const yOffset = -25;

    setOffsetPopover({
      left: clientX + xOffset,
      top: clientY + yOffset,
    });

    setVisiblePop(true);
  };

  const handleClickOpenModal = (value) => {
    setDetailModal(value);
    setIsOpen(true);
    setFromTacking(true);
  };
  const PopoverContent = (
    <div
      onMouseLeave={() => {
        setVisiblePop(false);
      }}
    >
      <div>
        <Button
          className="customer-button"
          style={{ width: "100%" }}
          type="text"
          onClick={(e) => {
            openViewQueue();
            // setOffsetPopover({ left: 0, top: 0 });
            setVisiblePop(false);
          }}
        >
          <Typography>
            <FormattedMessage id="btnView" defaultMessage="View" />
          </Typography>
        </Button>
      </div>
      {_.get(recordQueue, "statusMapView.statusFlowCode") === "enroute" ||
      _.get(recordQueue, "statusMapView.statusFlowCode") === "waiting" ||
      _.get(recordQueue, "statusMapView.statusFlowCode") === "open" ? (
        <div>
          <Button
            className="customer-button"
            style={{ width: "100%" }}
            type="text"
            onClick={() => {
              showConfirm(recordQueue);
              // setOffsetPopover({ left: 0, top: 0 });
            }}
          >
            <Typography>
              <FormattedMessage
                id="btnChangeDeliver"
                defaultMessage="เปลี่ยนเป็นจัดส่งเอง"
              />
            </Typography>
          </Button>
        </div>
      ) : null}
    </div>
  );

  const showTotal = () => {
    return (
      <span style={{ fontSize: "13px" }}>
        <FormattedMessage id="lblRowPerPage" defaultMessage="Rows per page: " />
      </span>
    );
  };

  const perth =
    "/" +
    " " +
    intl.formatMessage({
      id: "lblPerPage",
      defaultMessage: "page",
    });

  const paginationLocale = {
    items_per_page: perth,
  };

  const PageSizeSelector = ({
    onPageSizeChange,
    pageSizeOptions,
    defaultPageSize,
  }) => (
    <Select
      defaultValue={defaultPageSize}
      onChange={onPageSizeChange}
      options={pageSizeOptions.map((size) => ({
        value: size,
        label: `${size} / page`,
      }))}
      style={{ marginRight: "10px", width: "100%" }}
    />
  );

  const showConfirm = async (record) => {
    const timelimit = _.get(record, "waitingMinutes");
    const modal = confirm({
      title: (
        <Typography
          isBold
          color={COLORS.Purple}
          style={{ lineHeight: "1.5" }}
          size="18px"
          className="text-left pt-2"
        >
          {timelimit > 30
            ? intl.formatMessage({
                id: "changeStatusQueue2",
                defaultMessage: "คุณต้องการเปลี่ยนเป็นจัดส่งเอง",
              })
            : intl.formatMessage({
                id: "changeStatusQueue1",
                defaultMessage:
                  "การเปลี่ยนเป็นจัดส่งเอง ขณะนี้คุณยังรอไม่เกิน 30 นาที จะมีการคิดค่าใช้จ่ายตามปกติ",
              })}
        </Typography>
      ),
      icon: (
        <ExclamationCircleOutlined
          className="pt-2"
          style={{ color: COLORS.YellowPending, fontSize: "28px" }}
        />
      ),
      style: { marginLeft: "-10px" },
      width: isDesktop ? 550 : "100%",
      centered: true,
      footer: (
        <IntlProvider>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            <MyButton
              onClick={() => {
                modal.destroy();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="ยกเลิก" />
            </MyButton>
            <MyButton
              isPrimary
              // onClick={handleClickSave}
              onClick={() => {
                openConfirmModal();
                modal.destroy();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnConfirm" defaultMessage="ยืนยัน" />
            </MyButton>{" "}
          </div>
        </IntlProvider>
      ),
    });
  };

  const openConfirmModal = async () => {
    const payload = {
      _id: _.get(recordQueue, "_id"),
      comment: "ทดสอบ update order type 1 28/03/68",
    };
    const response = await UpdateStatusQueue(
      payload,
      _.get(recordQueue, "_id")
    );
    console.log("responseeeeee", response);
    if (_.get(response, "status") === 200) {
      successNotification(_.get(response, "message"));
      setEvent((prev) => !prev);
    } else {
      errorNotification(_.get(response, "message"));
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px",
        backgroundColor: "white",
        width: "100%",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <div className="py-3 px-4 d-flex align-items-center justify-content-between">
          <Typography isBold color={COLORS.Dark}>
            <FormattedMessage
              id="QueueListTitle"
              defaultMessage="คิวนำส่งสินค้า"
            />
          </Typography>

          <Button
            style={{
              backgroundColor: COLORS.GreenBrown,
              width: isDesktop ? null : "35px",
              padding: isDesktop ? null : "2px 5px",
              height: "35px",
            }}
            type="primary"
            onClick={exportOrdersList}
          >
            <img
              src={exportimg}
              style={{
                width: isDesktop ? "20px" : "20px",
                marginBottom: isDesktop ? "4px" : null,
                marginRight: isDesktop ? "7px" : null,
              }}
            />{" "}
            {isDesktop ? (
              <FormattedMessage
                id="labelShipmentExport"
                defaultMessage="Export"
              />
            ) : null}
          </Button>
        </div>
        <Divider className="m-3" />
        <div
          className={isDesktop ? "px-4 py-0" : "py-0 px-0"}
          // style={{ height: "calc(100vh - 520px)", overflowY: "auto" }}
        >
          {_.map(queueData, (element, index) => {
            return (
              <Popover
                overlayClassName="custom-popover"
                showArrow
                placement="left"
                open={visiblePop}
                content={PopoverContent}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                overlayStyle={{
                  position: "fixed",
                  left: offsetPopover.left,
                  top: offsetPopover.top,
                  maxWidth: "300px", // กำหนดขนาดสูงสุด
                  width: "fit-content", // ใช้ขนาดตามเนื้อหา
                  overflow: "hidden", // ป้องกัน overflow
                }}
                onClick={(e) => {
                  handleDivClick(e);
                  onClickView(element);
                  setVisiblePop(true);
                }}
                zIndex={999}
                trigger="click"
                destroyTooltipOnHide={true}
              >
                {index !== 0 && <Divider className="mx-0 my-3" />}
                <QueueListItem
                  queueInfo={element}
                  trackingDetail={trackingDetail}
                  handleClickOpenModal={handleClickOpenModal}
                />
                {index === _.size(queueData) - 1 && (
                  <Divider className="mx-0 my-3" />
                )}
              </Popover>
            );
          })}
        </div>
        {isDesktop ? (
          <div className="d-flex justify-content-between align-items-center pl-4">
            <div>
              <span style={{ fontSize: "13px" }}>
                <FormattedMessage id="lblTotal" defaultMessage="Total" />
                {` ${total || 0} `}
                <FormattedMessage id="lblitems" defaultMessage="items" />
              </span>
            </div>
            <div
              className="custom-pagination"
              style={{ textAlign: "right", padding: "16px 24px" }}
            >
              <Pagination
                defaultCurrent={1}
                total={total}
                onChange={handleChangePage}
                showSizeChanger={true}
                showTotal={showTotal}
                pageSizeOptions={["10", "20", "50", "100"]}
                defaultPageSize={"10"}
                current={pagination}
                locale={paginationLocale}
                pageSize={size}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-between align-items-center pl-4">
              <div>
                <span style={{ fontSize: "13px" }}>
                  <FormattedMessage id="lblTotal" defaultMessage="Total" />
                  {` ${total || 0} `}
                  <FormattedMessage id="lblitems" defaultMessage="items" />
                </span>
              </div>
              <div
                className="custom-pagination"
                style={{ textAlign: "right", padding: "16px 24px" }}
              >
                <PageSizeSelector
                  defaultPageSize={size}
                  pageSizeOptions={["10", "20", "50", "100"]}
                  onPageSizeChange={handleChangeSize}
                />
              </div>
            </div>
            <div style={{ textAlign: "center", padding: "16px 24px" }}>
              <Pagination
                defaultCurrent={1}
                total={total}
                onChange={handleChangePage}
                showSizeChanger={true}
                // showTotal={showTotal}
                pageSizeOptions={["10", "20", "50", "100"]}
                defaultPageSize={10}
                current={pagination}
                locale={paginationLocale}
                pageSize={size}
              />
            </div>
          </div>
        )}
        {/* <div style={{ textAlign: "center", padding: "16px 24px" }}>
          <Pagination
            defaultCurrent={1}
            total={total}
            onChange={handleChangePage}
            showSizeChanger={false}
          />
        </div> */}
      </div>

      <ShipmentDetailModal
        info={detailModal}
        isOpen={isOpen}
        onCancle={() => {
          setIsOpen(false);
          setFromTacking(false);
        }}
        onClickPrint={() => {}}
        onCancleShipment={() => {}}
        trackingDetail={trackingDetail}
        isPreview
        setEvent={setEvent}
        setIsOpen={setIsOpen}
        fromTracking={fromTracking}
        queueData={queueData}
        setDetailModal={setDetailModal}
      />
    </div>
  );
};

export default QueueList;
